import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import * as React from 'react';
import { FlatTypeFilterContainer } from '../../containers/flat_type_filter';
import { FloorFilterContainer } from '../../containers/floor_filter';
import { MVKPhase } from '../../types/mvk_state';
import { trackFlatInFloorPlanClick } from '../../utils/tracking';
import { Compass } from '../Compass';
import { PolygonsDrawer } from '../polygons_drawer';
import { DEFAULT_FLAT_POLYGON_FILL_STYLE, getColoredPolygons } from '../polygons_drawer/helpers';
import * as styles from './index.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var FloorScheme = /*#__PURE__*/function (_React$Component) {
  _inherits(FloorScheme, _React$Component);
  var _super = _createSuper(FloorScheme);
  function FloorScheme(props) {
    var _this;
    _classCallCheck(this, FloorScheme);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "floorPlanContainer", null);
    _defineProperty(_assertThisInitialized(_this), "backgroundImageSize", void 0);
    _defineProperty(_assertThisInitialized(_this), "floorPlanContainerRef", function (container) {
      _this.floorPlanContainer = container;
      _this.setState({
        isFloorPlanContainerMounted: true
      });
    });
    _defineProperty(_assertThisInitialized(_this), "handleFlatPolygonClick", function (flatId) {
      trackFlatInFloorPlanClick(_this.props.isOfferCard);
      _this.props.setFlatId(flatId);
    });
    _defineProperty(_assertThisInitialized(_this), "onBackgroundLoaded", function (size) {
      _this.backgroundImageSize = size;
    });
    _defineProperty(_assertThisInitialized(_this), "calculatePadding", function (canvasSize, scale) {
      var padding = [0, 0];
      if (_this.backgroundImageSize) {
        padding = padding.map(function (pad, index) {
          var imageSize = Math.round(_this.backgroundImageSize[index] / scale);
          return imageSize < canvasSize[index] ? Math.round(canvasSize[index] - imageSize) / 2 : pad;
        });
      }
      return padding;
    });
    _defineProperty(_assertThisInitialized(_this), "calculateScale", function (canvasSize) {
      if (_this.backgroundImageSize) {
        return Math.max(_this.backgroundImageSize[0] / canvasSize[0], _this.backgroundImageSize[1] / canvasSize[1]);
      }
      return 1;
    });
    _defineProperty(_assertThisInitialized(_this), "getImageDrawParams", function (canvasWidth, canvasHeight) {
      var canvasSize = [canvasWidth, canvasHeight];
      var scale = _this.calculateScale(canvasSize);
      var padding = _this.calculatePadding(canvasSize, scale);
      var _ref = _this.backgroundImageSize || canvasSize,
        _ref2 = _slicedToArray(_ref, 2),
        drawnImageWidth = _ref2[0],
        drawnImageHeight = _ref2[1];
      if (scale !== _this.state.scale || padding[0] !== _this.state.padding[0] || padding[1] !== _this.state.padding[1]) {
        _this.setState({
          padding: padding,
          scale: scale
        });
      }
      return {
        drawnImageHeight: drawnImageHeight,
        drawnImageWidth: drawnImageWidth,
        imageContainerHeight: drawnImageHeight / scale,
        imageContainerWidth: drawnImageWidth / scale,
        offsetLeft: padding[0],
        offsetTop: padding[1]
      };
    });
    _this.state = {
      isFloorPlanContainerMounted: false,
      padding: [0, 0],
      scale: 1
    };
    return _this;
  }
  _createClass(FloorScheme, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        floorScheme = _this$props.floorScheme,
        floorFlats = _this$props.floorFlats,
        setHoveredFlatId = _this$props.setHoveredFlatId,
        hoveredFlatId = _this$props.hoveredFlatId,
        currentPhase = _this$props.currentPhase,
        isFullScreen = _this$props.isFullScreen;
      if (!floorScheme || currentPhase !== MVKPhase.SECTION) {
        return null;
      }
      var _this$state = this.state,
        padding = _this$state.padding,
        scale = _this$state.scale,
        isFloorPlanContainerMounted = _this$state.isFloorPlanContainerMounted;
      var drawParams = {
        padding: padding,
        scale: scale
      };
      return /*#__PURE__*/_jsxs("div", {
        className: styles['container'],
        children: [/*#__PURE__*/_jsx(FlatTypeFilterContainer, {}), /*#__PURE__*/_jsx(FloorFilterContainer, {}), /*#__PURE__*/_jsx("div", {
          ref: this.floorPlanContainerRef,
          className: styles['polygons-container'],
          children: isFloorPlanContainerMounted && /*#__PURE__*/_jsx(PolygonsDrawer, {
            container: this.floorPlanContainer,
            polygons: getColoredPolygons(floorScheme.floorPlanFlats, floorFlats, hoveredFlatId),
            defaultColor: DEFAULT_FLAT_POLYGON_FILL_STYLE,
            background: floorScheme ? floorScheme.images.cianFull : '',
            backgroundDrawingAlgorythm: this.getImageDrawParams,
            onBackgroundLoaded: this.onBackgroundLoaded,
            drawParams: drawParams,
            onPolygonHover: setHoveredFlatId,
            onPolygonClick: this.handleFlatPolygonClick,
            isFullScreen: isFullScreen
          })
        }), /*#__PURE__*/_jsx(Compass, {
          azimuth: floorScheme.northDirection
        })]
      });
    }
  }]);
  return FloorScheme;
}(React.Component);